import "./DealsClosed.css";

import { ColorConstants } from "../../../../../constants";
import { formatNumber } from "../../../../../utils";
import { Card, ChartData } from "../../../../../widget";
import { useDealsClosed } from "./useDealsClosed";

interface DealsClosedProps {
  dealsClosedChartData: ChartData;
}

const STATUS_COLORS: Record<string, string> = {
  approved: ColorConstants.GREEN_500,
  rejected: ColorConstants.CORAL_500,
  cancelled: ColorConstants.INDIGO_500,
};

export const DealsClosed = ({ dealsClosedChartData }: DealsClosedProps): JSX.Element => {
  const { orderedEntries, total, formatStatusLabel } = useDealsClosed({ dealsClosedChartData });

  return (
    <Card corners="rounded" padding="ml" height="100%">
      <div className="DealsClosed">
        <p className="body01">Deals closed</p>
        <h1>{formatNumber(total) ?? "0"}</h1>
        <div className="DealsClosedList">
          {orderedEntries.length > 0 ? (
            orderedEntries.map((item) => {
              const percentage = total > 0 ? (item.value / total) * 100 : 0;
              const color = STATUS_COLORS[item.normalizedKey] ?? ColorConstants.GREY_300;

              return (
                <div className="DealsClosedRow" key={item.key}>
                  <div className="DealsClosedLabel">
                    <p className="body01 DealsClosedValue">{formatNumber(item.value) ?? "0"}</p>
                    <p className="body2 DealsClosedStatus">{formatStatusLabel(item.key)}</p>
                  </div>
                  <div className="DealsClosedBar">
                    <div className="DealsClosedBarFill" style={{ width: `${percentage}%`, backgroundColor: color }} />
                  </div>
                </div>
              );
            })
          ) : (
            <p className="body2 NoData">No data available</p>
          )}
        </div>
      </div>
    </Card>
  );
};
